import React, { useEffect, useState, useRef } from "react";
import { Box, Grid, Paper, Typography } from "@mui/material";
import HeadingComponent from "../../../../component/atom/Headings/Heading";
import {
  IconButtonComponent,
  SwitchButtonComponet,
  TextIconButtonComponent,
  TextInputComponent,
} from "../../../../component/atom";
import TableComponent from "../../../../component/atom/Table/TableComponent";
import DialogComponent from "../../../../component/atom/Dialog/Dialog";
import {
  AdminQuestions,
  AdminQuestionView,
  AdminQuizForm,
  AdminQuizView,
  AdminwebinarForm,
  PopUpMessageComponent,
  DocumentAssociationDialog,
  QandACard,
} from "../../../../component/molecule";
import { useLocation, useNavigate } from "react-router-dom";
import { faEye, faQuestionCircle } from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import { Actions } from "../../../../core/modules/Actions";
import _ from "lodash";
import moment from "moment";
import DropDownComponent from "../../../../component/atom/Inputs/DropDown";
import TextAreaComponent from "../../../../component/atom/Inputs/TextArea";
import { AdminQuestionsEdit } from "../../../../component/molecule/Forms";
import { useQuestionEdit } from "../../../../hook/useQuestionEdit";
import { ASSOCIATION_ACTION } from "../../../../core/Constant";

const AdminQuizSecondScreen = ({
  getQuizeList,
  quizList,
  upDateQuizState,
  getQuizById,
  deleteQuize,
  verifyToken,
  getAllStateCourseList,
  getCourseList,
  courseList,
  getQuizQuestionAndAnswerByQuizId,
  questionAndAnswersList,
  getCategoryList,
  getSubjectList,
  removeQuestionfromQuiz,
  rearrangeQuizQuestions,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [addQuestion, setAddQuestion] = useState(false);
  const [viewQuiz, setViewQuiz] = useState(false);
  const [deleteQuiz, setDeleteQuiz] = useState(false);
  const [selectQuiz, setSelectedQuiz] = useState("");
  const [editQuiz, setEditQuiz] = useState(false);
  const [courseId, setCourseId] = useState(0);
  const cQuizRef = useRef(null);
  const [list, setList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [questionsList, setQuestionsList] = useState([]);
  const [viewQuestion, setViewQuestion] = useState(false);
  const [categoryIds, setCategoryIds] = useState([]);
  const [quizData, setQuizData] = useState({});
  const [draggedQuestionIndex, setDraggedQuestionIndex] = useState(null);
  const [dragOverIndex, setDragOverIndex] = useState(null);
  const [quizid, setQuizId] = useState(0);
  const [onDeletePopup, setOnDeletePopUp] = useState(false);
  const [allQuiz, setAllQuiz] = useState([]);

  const {
    selectedItem,
    setSelectedItem,
    showEditWarning,
    editQuestion,
    editingQuestionId,
    associateQuizzes,
    handleEditQuestion,
    onConfirmEdit,
    onCancelEdit,
    onEditQuestionClose,
  } = useQuestionEdit();

  const [showToast, setShowToast] = useState(false);
  const [toastTitle, setToastTitle] = useState("Create Quiz");
  const [toastMessage, setToastMessage] = useState("Quiz created successfully");

  useEffect(() => {
    const routeState = location?.state;
    let storedQuizData = null;

    try {
      storedQuizData = JSON.parse(localStorage.getItem("newQuiz") || "null");
    } catch (e) {
      console.error("Failed to parse newQuiz from localStorage", e);
    }

    const activeQuizData = routeState?.quizData || storedQuizData;
    const activeQuizId = routeState?.id || activeQuizData?.id;

    if (activeQuizId) {
      setQuizData(activeQuizData || { id: activeQuizId });
      setQuizId(activeQuizId);
      getQuizQuestionAndAnswerByQuizId(activeQuizId);
    }

    if (
      routeState?.showSuccessDialog ||
      routeState?.showSuccess ||
      routeState?.isNewQuiz
    ) {
      setShowToast(true);
      if (routeState?.title) setToastTitle(routeState.title);
      if (routeState?.successMessage || routeState?.toastMessage) {
        setToastMessage(routeState.successMessage || routeState.toastMessage);
      }

      const timer = setTimeout(() => {
        setShowToast(false);
      }, 3500);

      return () => clearTimeout(timer);
    }

    getCategoryList();
    getSubjectList();
  }, [location?.state]);

  useEffect(() => {
    setQuestionsList(questionAndAnswersList)
  }, [questionAndAnswersList])

  useEffect(() => {
    if (questionsList?.length > 0) {
      const ids = questionsList
        .filter(Boolean)
        .map((question) => question.category_id);
      setCategoryIds(ids);
    }
  }, [questionsList]);

  useEffect(() => {
    if (courseId == 0 && Array.isArray(quizList)) {
      const list = quizList
        .filter(Boolean)
        .map((item) => {
        const createdDate = moment(_.get(item, "created_at", new Date())).format(
          "DD/MM/YYYY HH:mm:ss"
        );
        return { ...item, createdDate };
      });
      setAllQuiz(list);
    }
  }, [quizList, courseId]);

  useEffect(() => {
    getQuizeList();
    getAllStateCourseList();
    getCourseList();
  }, []);

  const onDeleteQuize = () => {
    deleteQuize(selectQuiz);
    onDeleteClose();
  };

  const onDeleteClose = () => {
    setDeleteQuiz(false);
    setSelectedQuiz("");
  };

  const onViewOff = () => {
    setViewQuestion(false);
    setSelectedItem({});
  };

  const handleEditQuestionClose = () => {
    onEditQuestionClose(() => {
      if (quizid) {
        getQuizQuestionAndAnswerByQuizId(quizid);
      }
    });
  };

  const onDelete = () => {
    setOnDeletePopUp(false);
    removeQuestionfromQuiz({
      quiz_id: quizid,
      question_id: selectedItem?.id
    })
    _.delay(() => {
      setSelectedItem({});
    }, 1000);
  };

  const onNotDelete = () => {
    setOnDeletePopUp(false);
    setSelectedItem({});
  };

  const persistReorderedQuestions = () => {
    const questionIds =
      questionsList
        ?.map((question) => question?.id ?? question?.question_id)
        ?.filter(Boolean) || [];
    if (quizid && questionIds.length > 0) {
      rearrangeQuizQuestions({
        quiz_id: quizid,
        question_ids: questionIds,
      });
    }
  };

  const handleQuestionDragStart = (event, index) => {
    event.dataTransfer.effectAllowed = "move";
    try {
      event.dataTransfer.setData("text/plain", String(index));
    } catch (error) {
      // ignore for browsers that block setData
    }
    setDraggedQuestionIndex(index);
    setDragOverIndex(index);
  };

  const handleQuestionDragOver = (event, index) => {
    event.preventDefault();
    event.dataTransfer.dropEffect = "move";
    if (draggedQuestionIndex === null || draggedQuestionIndex === index) {
      return;
    }
    if (dragOverIndex !== index) {
      setDragOverIndex(index);
    }
  };

  const handleQuestionDrop = (event, index) => {
    event.preventDefault();
    if (draggedQuestionIndex === null || draggedQuestionIndex === index) {
      handleQuestionDragEnd();
      return;
    }
    setQuestionsList((prev) => {
      if (!Array.isArray(prev)) {
        return prev;
      }
      const updated = [...prev];
      const [movedQuestion] = updated.splice(draggedQuestionIndex, 1);
      updated.splice(index, 0, movedQuestion);
      return updated;
    });
    handleQuestionDragEnd();
  };

  const handleQuestionDragLeave = (index) => {
    if (dragOverIndex === index) {
      setDragOverIndex(null);
    }
  };

  const handleQuestionDragEnd = () => {
    setDraggedQuestionIndex(null);
    setDragOverIndex(null);
  };

  return (
    <>
      <Box className="main-screen-container" sx={{ position: "relative" }}>
        <Grid container direction="row" justifyContent="space-between">
          <Grid item>
            <HeadingComponent
              text={"Add Quiz"}
              fontweigth={600}
              size={40}
              backNavigation={true}
              fontfamily={"Montserrat"}
            />
          </Grid>

          <Grid item className="student-search-btn-section" columnGap={2}>
            <TextIconButtonComponent
              btnText={"Add Question"}
              icon={faQuestionCircle}
              animation={"shake"}
              onclick={() => setAddQuestion(true)}
            />
            <TextIconButtonComponent
              btnText={"Select Question"}
              icon={faEye}
              onclick={() => navigate("/admin-question-select")}
            />
          </Grid>
        </Grid>
        <Box className="common-admin-content-wrap">
          <Grid container>
            <Grid item>
              <HeadingComponent
                fontfamily={"Montserrat"}
                size={24}
                color={"#4e657c"}
                text={
                  "Selected Questions"
                }
              />

            </Grid>
          </Grid>
          <Grid container>
            <Grid xs={12}>
              {questionsList.map((item, index) => (
                <QandACard
                  key={item?.id || index}
                  isView={true}
                  isEdit={true}
                  isDelete={true}
                  draggable
                  onDragStart={(event) => handleQuestionDragStart(event, index)}
                  onDragOver={(event) => handleQuestionDragOver(event, index)}
                  onDrop={(event) => handleQuestionDrop(event, index)}
                  onDragEnd={handleQuestionDragEnd}
                  onDragLeave={() => handleQuestionDragLeave(index)}
                  isDragging={draggedQuestionIndex === index}
                  isDragOver={
                    dragOverIndex === index && draggedQuestionIndex !== index
                  }
                  onclick={() => {
                    setViewQuestion(true);
                    setSelectedItem(item);
                  }}
                  onPressEdit={() => handleEditQuestion(item, quizData?.quiz_name || quizData?.name)}
                  isEditing={editingQuestionId === (item?.id ?? item?.question_id)}
                  onPressDelete={() => {
                    setOnDeletePopUp(true);
                    setSelectedItem(item);
                  }}
                  index={index}
                  item={item}
                />
              ))}
            </Grid>
          </Grid>

          <Grid mt={10} alignItems={'flex-end'} justifyContent={'flex-end'} container>
            <Grid item >

              <TextIconButtonComponent
                btnText={"Next"}
                animation={"shake"}
                onclick={() => {
                  persistReorderedQuestions();
                  navigate('/admin-quiz-grade', { state: { categoryIds: categoryIds } });
                }}
              />
            </Grid>

          </Grid>
        </Box>

        {/* Animated Checkmark Toast Popup */}
        {showToast && (
          <Paper elevation={2} className="toast-paper-card">
            <Box className="toast-card-content">
              <svg width="48" height="48" viewBox="0 0 56 56" fill="none">
                <circle
                  className="animated-circle"
                  cx="28"
                  cy="28"
                  r="24"
                  stroke="#72C07B"
                  strokeWidth="3.5"
                />
                <path
                  className="animated-checkmark"
                  d="M17 28L24.5 35.5L39 20.5"
                  stroke="#72C07B"
                  strokeWidth="3.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>

              <Box>
                <Typography className="toast-title">
                  {toastTitle}
                </Typography>
                <Typography className="toast-subtitle">
                  {toastMessage}
                </Typography>
              </Box>
            </Box>

            {/* Bottom Progress Line */}
            <Box className="toast-bottom-bar">
              <Box className="toast-bottom-line-fill" />
            </Box>
          </Paper>
        )}
      </Box>
      <PopUpMessageComponent
        open={deleteQuiz}
        type={"other"}
        title={"Delete!"}
        message={"Are you sure you want delete quiz?"}
        btntext={"Yes, delete"}
        altbtntext={"No"}
        onclick={onDeleteQuize}
        altonclick={onDeleteClose}
        onclose={onDeleteClose}
      />

      <AdminQuestions
        open={addQuestion}
        quizData={quizData}
        onClose={() => {
          setAddQuestion(false);
          if (quizid) {
            getQuizQuestionAndAnswerByQuizId(quizid);
          }
        }}
      />
      <DialogComponent
        isShowCloseButton={true}
        title={"View Question"}
        maxwidth={"lg"}
        open={viewQuestion}
        onClose={onViewOff}
      >
        <AdminQuestionView item={selectedItem} onClose={onViewOff} />
      </DialogComponent>

      <DialogComponent
        isShowCloseButton={true}
        title={"Edit Question"}
        maxwidth={"lg"}
        open={editQuestion}
        onClose={handleEditQuestionClose}
      >
        <AdminQuestionsEdit
          questionDetails={selectedItem}
          onClose={handleEditQuestionClose}
        />
      </DialogComponent>

      {showEditWarning && (
        <DocumentAssociationDialog
          association={{
            data: associateQuizzes,
            action: ASSOCIATION_ACTION.EDIT,
            entityType: "question",
            entityName: (selectedItem?.question || selectedItem?.name || "").replace(/<[^>]*>/g, ""),
          }}
          onConfirm={onConfirmEdit}
          onClose={onCancelEdit}
        />
      )}

      <PopUpMessageComponent
        open={onDeletePopup}
        type={"other"}
        title={"Delete!"}
        message={"Are you sure you want delete this question ?"}
        btntext={"Yes, delete"}
        altbtntext={"No"}
        altonclick={onNotDelete}
        onclick={onDelete}
        onclose={onNotDelete}
      />
    </>
  );
};

export default connect(
  (state) => ({
    quizList: state.quizes.get("quizList"),
    courseList: state.students.get("commonCourseList"),
    questionAndAnswersList: state.quizes.get("questionAndAnswersList"),
  }),
  {
    getQuizeList: Actions.quizes.getQuizeList,
    upDateQuizState: Actions.quizes.upDateQuizState,
    getQuizById: Actions.quizes.getQuizById,
    deleteQuize: Actions.quizes.deleteQuize,
    verifyToken: Actions.auth.verifyToken,
    getAllStateCourseList: Actions.course.getAllStateCourseList,
    getCourseList: Actions.quizes.getCourseListByQuiz,
    getQuizQuestionAndAnswerByQuizId:
      Actions.quizes.getQuizQuestionAndAnswerByQuizId,
    getCategoryList: Actions.questions.getCategoryList,
    getSubjectList: Actions.questions.getSubjectList,
    removeQuestionfromQuiz: Actions.quizes.removeQuestionfromQuiz,
    rearrangeQuizQuestions: Actions.quizes.rearrangeQuizQuestions,
  }
)(AdminQuizSecondScreen);
